import * as React from 'react';
import {Node} from "../../../../model/Graph";
import {withNamespaces, WithNamespaces} from "react-i18next";
import {Checkbox, FormField, Message} from "semantic-ui-react";

interface OwnProps {
  command: Node | null;
  deleteState: boolean | undefined;
  deleteHistory: boolean | undefined;
  onDeleteHistoryChanged: (deleteHistory: boolean) => void;
  disabled?: boolean;
}

type DeleteHistoryToggleProps = OwnProps & WithNamespaces;

const DeleteHistoryToggle = (props: DeleteHistoryToggleProps) => {
  const disabled = !props.command || !props.deleteState;
  return <FormField disabled={disabled} inline={true} className={disabled? 'fadeout' : 'fadein'}>
    <Checkbox value={1}
              checked={props.deleteHistory}
              disabled={props.disabled || disabled}
              toggle={true}
              onChange={() => props.onDeleteHistoryChanged(!props.deleteHistory)}
              label={props.t('insp.cody_wizard.step_command.delete_history_label') as string} />
    <Message size="small" warning={true}
             icon="eraser"
             content={props.t('insp.cody_wizard.step_command.delete_history_warning')}
             style={{display: props.deleteHistory? 'flex' : 'none'}}
    />
  </FormField>
};

export default withNamespaces()(DeleteHistoryToggle);
